export const VERSION_TABLE_ACTION = { EXPAND: "version-expand" };

export const VERSION_DEFAULT_SORT = { sortBy: "name", orderBy: "asc" };

export const EVOLUTION_RANGE = { LAST_7: 7, LAST_30: 30 };
